module.exports = __webpack_public_path__ + "static/media/wallet-request-loan.2c3fa149.png";